import { render, staticRenderFns } from "./caseBox.vue?vue&type=template&id=6a1e8ad9&"
import script from "./caseBox.vue?vue&type=script&lang=js&"
export * from "./caseBox.vue?vue&type=script&lang=js&"
import style0 from "./caseBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports